import currentRoute from './currentRoute';
import { RouteAccess } from './types';
import type { RouteConfigExtended, RouteConfigOption } from './types';

export const getRouteConfig = (route?: RouteConfigExtended): RouteConfigOption => {
    if (!route) {
        return { access: RouteAccess.Public, tab: undefined };
    }

    return route.config || { tab: undefined };
};

export const currentRouteConfig = (routes: RouteConfigExtended[]): RouteConfigOption => {
    const route = currentRoute(routes);

    return getRouteConfig(route);
};
